import { TERMINOLOGY } from '../../../constants/terminology';

export const CHILD_TEAM_ACTION_COPY = {
  careTeamTitle: TERMINOLOGY.careCircle,
  careTeamFallback: 'Invite and manage caregivers',
  careTeamManageLabel: 'Invite members and manage access',
  inviteTeamMember: 'Invite Team Member',
  manageTeam: 'Manage Team',
  shareCareSummary: 'Share Care Summary',
  careSummaryTitle: 'Care Summary',
  careSummarySubtitle: 'Review patterns and key moments before a visit or handoff.',
  editChildInfo: TERMINOLOGY.editSubject,
  importPastData: 'Add Care Source',
};

export const getCareTeamSupportText = (memberCount = 0, roleDisplay = null) => {
  if (roleDisplay?.plainLabel === 'Care Owner' || roleDisplay?.plainLabel === 'Care Partner') {
    return 'Manage team';
  }

  if (memberCount > 0) {
    return `${memberCount} ${memberCount === 1 ? 'member' : 'members'}`;
  }

  if (roleDisplay?.dashboardHint) {
    return roleDisplay.dashboardHint;
  }

  return CHILD_TEAM_ACTION_COPY.careTeamFallback;
};
